import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import CardList from './CardList';
import Loading from '../Loading';
import SEO from '../SEO';

import styleClasses from './css/MusicardList.module.scss';

function MusicardList() {
  const [musicians, setMusicians] = useState([]); // Firestore 데이터를 저장할 상태
  const [loading, setLoading] = useState(true); // 로딩 상태 관리

  useEffect(() => {
    const fetchMusicians = async () => {
      try {
        // 'act' 필드가 true인 문서만 가져오는 쿼리 생성
        const musiciansQuery = query(
          collection(db, 'musicians'), // 컬렉션 참조
          where('act', '==', true)    // act 필드가 true인 문서 필터링
        );
  
        // Firestore에서 쿼리 실행
        const querySnapshot = await getDocs(musiciansQuery);
        const fetchedMusicians = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
  
        setMusicians(fetchedMusicians); // 상태에 데이터 저장
      } catch (error) {
        console.error('Error fetching musicians data:', error.message);
      } finally {
        setLoading(false); // 로딩 상태 해제
      }
    };
  
    fetchMusicians();
  }, []); // 의존성 배열은 빈 배열로 설정

  if (loading) return <Loading />;

  // CardSlider에 전달할 데이터를 재구성
  const cards = musicians.map((musician) => ({
    id: musician.id,
    title: musician.name,
    description: musician.genres.join(', '), // 장르 배열을 쉼표로 연결된 문자열로 변환
    positions: musician.positions, // 포지션 배열 그대로 전달
    genres: musician.genres, // 장르 배열 그대로 전달
    image: musician.profileImage, // 프로필 이미지 전달
  }));

  return (
    <>
      <SEO title='MusiCards'/>
      <div className={ styleClasses.inner }>
        <div className={ styleClasses.musicianList }>
          <div className={ styleClasses.wrapper }>
            <div className={ styleClasses.mainHeader }>
              <h1 className={ styleClasses.title }>MusiCards</h1>
              <div className={ styleClasses.description }>
                <p>인디 뮤지션들의 소리를 기록하는 곳, 뮤지직에 오신 걸 환영합니다. <br />다양한 아티스트 분들의 뮤지카드를 즐겨주세요.</p>
                <p>Welcome to MUSIZIC, the place where we document the sounds of independent musicians. <br />We hope you enjoy our selection of MusiCards from a variety of artists.</p>
              </div>
            </div>
            {/* CardSlider 컴포넌트 사용 */}
            <CardList cards={ cards } />
          </div>
        </div>
      </div>
    </>
  );
}

export default MusicardList;
